import ErrorMessage from '@/components/ui/error-message';
import { useCategories } from '@/framework/category';
import dynamic from 'next/dynamic';

const StickySidebarListCategories = dynamic(
  () => import('@/components/categories/sticky-sidebar-list-categories'),
);
const FilterCategoryGrid = dynamic(
  () => import('@/components/categories/filter-category-grid'),
);

const MAP_CATEGORY_TO_GROUP: Record<string, any> = {
  classic: StickySidebarListCategories,
  minimal: FilterCategoryGrid,
};

interface CategoriesProps {
  layout: string;
  variables: any;
  className?: string;
  title?: string;
}
export default function Categories({
  layout,
  className = '',
  variables,
  title,
}: CategoriesProps) {
  const { categories, isLoading, error } = useCategories(variables);

  if (error) return <ErrorMessage message={error.message} />;
  const Component =
    MAP_CATEGORY_TO_GROUP[layout] ?? MAP_CATEGORY_TO_GROUP['minimal'];

  return (
    <Component
      notFound={!Boolean(categories.length)}
      categories={categories}
      loading={isLoading}
      className={className}
      variables={variables}
      title={title}
    />
  );
}
